module.exports = __webpack_public_path__ + "static/media/ravaupma.e02c500a.jpg";